// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__1pEkk","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__2s6K3"};